// extracted by mini-css-extract-plugin
module.exports = {"group":"style_group__TIlz+","name":"style_name__mjtKt","chip":"style_chip__7V73w","heading":"style_heading__aa3Wg","loadMore":"style_loadMore__Lgquk"};